import * as React from 'react';
// @ts-expect-error
import {DropTarget, ConnectDropTarget} from 'react-dnd';

import {LeadStatusIcon} from 'shells/icon/lead-status-icon';

import {dragItemTypes, dropResultTypes} from '../dnd/drag-item-types';
import type {CloseButtonDropResult} from '../dnd/drag-item-types';

import styles from './visual-pipeline-close-lead-drop-target.module.css';

const CLOSE_LEAD_MAP = {
    win: {
        styleName: styles['button-win'],
        styleNameHovered: styles['button-win--hovered'],
        imgSrc: <LeadStatusIcon status='WON' width={32} />,
        buttonText: 'Win lead',
    },
    lose: {
        styleName: styles['button-lose'],
        styleNameHovered: styles['button-lose--hovered'],
        imgSrc: <LeadStatusIcon status='LOST' width={32} />,
        buttonText: 'Lose lead',
    },
    cancel: {
        styleName: styles['button-cancel'],
        styleNameHovered: styles['button-cancel--hovered'],
        imgSrc: <LeadStatusIcon status='CANCELLED' width={32} />,
        buttonText: 'Cancel lead',
    },
} as const;

type Props = {
    type: 'win' | 'lose' | 'cancel';
    buttonRef: (arg1?: HTMLElement | null | undefined) => any;
    // From react-dnd
    connectDropTarget?: ConnectDropTarget;
    isOver?: boolean;
};

export class VisualPipelineCloseLeadDropTargetComponent extends React.PureComponent<Props> {
    render() {
        const {styleName, styleNameHovered, imgSrc, buttonText} = CLOSE_LEAD_MAP[this.props.type];

        return this.props.connectDropTarget(
            <div
                ref={this.props.buttonRef}
                className={this.props.isOver ? styleNameHovered : styleName}
            >
                {imgSrc}
                <span>{buttonText}</span>
            </div>
        );
    }
}

const leadCardTarget = {
    // @ts-expect-error
    drop(props): CloseButtonDropResult {
        return {
            type: dropResultTypes.CLOSE_BUTTON,
            payload: {
                closeType: props.type,
            },
        };
    },
} as const;

// @ts-expect-error
const leadCardConnect = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
});

export const VisualPipelineCloseLeadDropTarget = DropTarget(
    dragItemTypes.LEAD_CARD,
    leadCardTarget,
    leadCardConnect
)(VisualPipelineCloseLeadDropTargetComponent);
